import { render, staticRenderFns } from "./selectbit.vue?vue&type=template&id=8c94a728&"
import script from "./selectbit.vue?vue&type=script&lang=js&"
export * from "./selectbit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports